<div class="enter-postal-code-label">
    {{ 'COMPANY_SEARCH.PLEASE_ENTER_YOUR_POSTAL_CODE_OR_CITY' | translate }}
</div>
<div
    aria-hidden="true"
    class="map-image"
    [style.background-image]="'url(shared-assets/images/company-search/map.png'"
></div>
